import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Minimalist%20e-commerce%20aesthetic%20workspace%20with%20a%20clean%20laptop%20on%20light%20wooden%20desk%20surrounded%20by%20neatly%20arranged%20fashion%20accessories%20and%20clothing%20items%2C%20soft%20natural%20daylight%20streaming%20through%20a%20window%20creating%20gentle%20shadows%2C%20pastel%20beige%20cream%20and%20warm%20taupe%20tones%20dominate%2C%20modern%20Scandinavian%20interior%20design%2C%20airy%20and%20fresh%20composition%20with%20ample%20negative%20space%2C%20editorial%20product%20photography%20style%20with%20soft%20focus%20background%2C%20warm%20neutral%20color%20palette%2C%20elegant%20and%20sophisticated%20product%20presentation&width=1600&height=900&seq=yoybuy-hero-bg-001&orientation=landscape"
        alt="YOYBUY Spreadsheet — система заказов товаров из Китая"
        title="YOYBUY Spreadsheet — система заказов товаров из Китая"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs md:text-sm font-semibold tracking-wider uppercase mb-4 md:mb-6">
          #1 Spreadsheet для заказов из Китая
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white leading-tight mb-3 md:mb-4 max-w-3xl">
          YOYBUY <span className="text-primary-300">Spreadsheet</span>
        </h1>
        <p className="text-sm md:text-lg text-white/85 max-w-xl mb-6 md:mb-8 leading-relaxed">
          Удобная система заказов товаров из Китая через таблицу. Покупайте одежду, обувь и аксессуары с полным контролем каждого заказа.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line w-4 h-4 md:w-5 md:h-5 flex items-center justify-center" />
            YOYBUY SHEET
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-flashlight-line w-4 h-4 md:w-5 md:h-5 flex items-center justify-center" />
            BUY IT NOW
          </a>
        </div>
        <Link
          to="/blog/yoybuy-spreadsheet-instruktsiya"
          className="mt-6 md:mt-8 text-white/70 hover:text-white text-xs md:text-sm underline underline-offset-4 transition-colors cursor-pointer"
        >
          Читать полное руководство по YOYBUY Spreadsheet →
        </Link>
      </div>
    </section>
  );
}